<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-11-03 17:10:00
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-11-28 16:05:05
-->
<template>
	<div>
		<el-dialog title="提示" :visible.sync="visible" width="400px" @close="handleClose">
			<div class="tip">
				<p class="font-h4-regular yx-color-text-primary flex-row">
					<i class="el-icon-warning font-h1-regular"></i>
					<span class="ml-10">微信【{{ wxNickName }}】在其他团队已绑定手机号，请解绑后再保存。</span>
				</p>
			</div>
			<span slot="footer">
				<el-button @click="handleClose">我知道了</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
			wxNickName: '',
		};
	},
	methods: {
		show(wxNickName = []) {
			this.wxNickName = wxNickName;
			this.visible = true;
		},
		handleClose() {
			this.visible = false;
			this.wxNickName = [];
		},
	},
};
</script>
<style lang="less" scoped>
.tip {
	i {
		color: @color-warning;
		position: relative;
		top: 2px;
	}
}
</style>
